module.exports = __webpack_public_path__ + "static/media/icon-arrow-left.3f55efb1.svg";